import { render, staticRenderFns } from "./cdeclaredetail.vue?vue&type=template&id=6065f8f1&scoped=true"
import script from "./cdeclaredetail.vue?vue&type=script&lang=js"
export * from "./cdeclaredetail.vue?vue&type=script&lang=js"
import style0 from "./cdeclaredetail.vue?vue&type=style&index=0&id=6065f8f1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6065f8f1",
  null
  
)

export default component.exports